export default "__VITE_ASSET__DNl47PI4__"